<template>
  <div id="login">
    <dd-header
      :headerType=1
    />
    <!-- <dd-info></dd-info> -->
    <div id="container">
      <div id="content">
        <div class="login_form">
          <div class="title">
            <div>
              <img :src="getImage('common/logo.png')" width="250px" height="auto">
            </div>
            <div>
              <label>My size, My lifestyle.</label>
            </div>
          </div>
          <dd-login></dd-login>
        </div>
        <div class="upper2" :style="upper2Style"></div>
        <section id="lp_02" :style="lp02Style">
          <div class="h2_bg">
            <h2><img :src="getImage('common/logo.png')" width="120px" height="auto" alt="ミリスタイル">とは？</h2>
            <img class="righttop_img" :src="getImage('login/worlds_first.png')" alt="世界初!!カスタマイズできるデジタルカタログ！"></div>
          <dl class="point_list container around">
            <div>
              <dt>Point.1</dt>
              <dd class="center">現場にあわせて<br>
                <span class="red">WHD</span>の3サイズが<br>
                オーダーできる！ </dd>
              <dd><span class="small_p">1mm単位で入力・カラーの選択だけで家具をその場でご注文いただけます！</span> </dd>
            </div>
            <div>
              <dt>Point.2</dt>
              <dd class="center">オーダーなのに<br>
                <span class="red">低価格＆短納期!!</span></dd>
              <dd><span class="small_p">必要な時に必要なものを必要なスタイルでオーダーできます!!</span> </dd>
            </div>
            <div>
              <dt>Point.3</dt>
              <dd class="center">図面も見積りも<br>
                その場で確認！<br>
                <span class="red">そのまま注文!!</span></dd>
              <dd><span class="small_p">図面と見積りは入力したサイズ・カラーに合わせて自動生成されます！</span> </dd>
            </div>
          </dl>
        </section>
        <div class="under" :style="underStyle"></div>
        <section id="lp_03">
          <h2><img :src="getImage('common/logo.png')" width="120px" height="auto" alt="ミリスタイル">では、</h2>
          <div class="lp_content">
            <p class="large_p">世界唯一のオーダー家具製造システムによって<br>
              低価格＆短納期でお届けすることが可能です！</p>
            <p class="small_p">※家具製作サポートシステム 特許第3079206号 その他多数出願中<br>
              ※その他特許 アメリカ 中国 韓国にて取得済み</p>
          </div>
        </section>
        <div class="upper" :style="upperStyle"></div>
        <section id="lp_04">
          <!-- スケール -->
          <h2>ご注文の流れ</h2>
          <div class="lp_content">
            <img id="lp_04_img" :src="getImage('what/desktop_order.png')" width="660px" height="auto" alt="1カテゴリを選択2商品を選びスペックを確認3カスタマイズする4その場で見積り">
          </div>
        </section>
        <section id="lp_05">
          <h2><img :src="getImage('common/logo.png')" width="120px" height="auto" alt="ミリスタイル">なら、</h2>
          <ul class="bold">
            <li>WHD全ての寸法を<span class="red">1mm</span>単位でオーダー</li>
            <li>簡単操作で<span class="red">30秒</span>で注文</li>
            <li>図面と見積りは<span class="red">3秒</span>で自動生成</li>
            <li><span class="red">100万戸</span>のスペースにフィットできる</li>
          </ul>
        </section>
        <div class="upper" :style="upperStyle"></div>
        <!-- スケール -->
        <section id="lp_06" :style="lp06Style">
          <h2>組立設置サービスについて</h2>
          <div class="lp_content">
            <div id="lp_06_content">
              ご購入いただいた家具の組立・設置を行うサービスです。<br>
              組み立てをご希望のお客様はお気軽にご依頼ください。<br>
              <br>
              ■組み立て業者：キャンディルグループ<br>
              （㈱キャンディルテクト／㈱バーンリペア）<br>
              <br>
              キャンディルグループでは、大手北欧家具メーカーや<br>
              国内有名メーカーなどの家具組み立てを行っております。<br>
              経験・知識が豊富なスペシャリストが対応しますので、スピーディーな作業が可能です。<br>
              安心しておまかせください。
            </div>
          </div>
        </section>
        <div class="under" :style="underStyle"></div>
        <section id="lp_07">
          <h2>無料で登録</h2>
          <div class="container lp_content">
            <div>
              <div id="lp_07_content_img" :style="lp07ContentImg"></div>
              <p>お見積り、図面生成を無料でご利用できます。<br>
                お気軽にお試しください。</p>
            </div>
            <div class="regist_form">
              <dd-login></dd-login>
            </div>
          </div>
        </section>
        <div class="upper" :style="upperStyle"></div>
        <section id="lp_08">
          <div class="lp_content container">
            <div class="lp_08_content bold">
              <h2>お問合せください</h2>
              <p>カタログにない仕様のご相談も承ります。<br>
                分からないことがございましたら<br>
                お気軽にお問い合わせください。</p>
            </div>
            <div class="lp_08_content">
              <div class="center"><img :src="getImage('common/logo.png')" width="80%" height="auto"  alt="ミリスタイル">
                <p class="letter_01">My size, My lifestyle.</p>
                <dl class="lp_contact">
                  <dt><img :src="getImage('login/icon_tel.svg')" width="40px" height="40px" alt="tel"></dt>
                  <dd class="large_p bold">03-6276-1123<br>
                    <span class="small_p">（ 平日 10:00-18:00 ）</span>
                  </dd>
                  <dt>
                    <router-link to="/mmstyle/support/input">
                      <img :src="getImage('login/icon_mail.svg')" width="40px" height="40px" alt="mail">
                    </router-link>
                  </dt>
                  <dd>
                    <router-link to="/mmstyle/support/input">お問合わせフォームはこちら</router-link>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </section>
        <div id="footer">
          <img :src="getImage('common/logo_domans.svg')">
        </div>
      </div><!-- end content -->
    </div>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import LoginForm from '../components/login/LoginForm'
import Information from '../components/common/Information'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm,
    'dd-info': Information
  },
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      },
      /**
       * スタイル
       */
      upperStyle: {
        background: 'url(' + this.getImage('login/mm.png') + ')',
        backgroundSize: 'contain'
      },
      upper2Style: {
        background: 'url(' + this.getImage('login/mm.png') + ')',
        backgroundSize: 'contain'
      },
      underStyle: {
        background: 'url(' + this.getImage('login/mm.png') + ')',
        backgroundSize: 'contain'
      },
      lp02Style: {
        background: 'url(' + this.getImage('login/room_blur.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      },
      lp05Style: {
        background: 'url(' + this.getImage('login/room_blur.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      },
      lp06Style: {
        backgroundImage: 'url(' + this.getImage('login/construction.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        backgroundSize: '50%'
      },
      lp07ContentImg: {
        backgroundImage: 'url(' + this.getImage('login/prototype_img.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        backgroundSize: 'contain'
      }
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
  }
}
</script>
<style src="../css/login.scss" lang="scss" scoped></style>
<style src="../css/style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/Login.vue